var React = require('react');
import SampleInput from './subcomponents/SampleInput';

class AddSample extends React.Component {

    constructor() {
        super();
        this.state = {
            samples: [],
            options: JSON.parse(document.getElementById('json_beers').value),
            checked: {}
        };
        this.clickOnAddSample = this.clickOnAddSample.bind(this);
        this.removeSample = this.removeSample.bind(this);
        this.chooseSample = this.chooseSample.bind(this);
        this.samples = this.samples.bind(this);
        this.storeSamples = this.storeSamples.bind(this);
    }

    namedSample() {
        const option = this.state.options[0];
        return {
            name: option ? option.name : '',
            selection: option ? option.id : 'new_beer',
            checked: {},
            cost: {}
        }
    }

    clickOnAddSample() {
        const samples = this.storeSamples().concat([this.namedSample()]);
        this.props.actions.changeSamples(samples);
    }

    removeSample(index) {
        let samples = this.storeSamples();
        samples.splice(index, 1);
        this.props.actions.changeSamples(samples);
    }

    chooseSample(index, selection, name) {
        let samples = this.storeSamples();
        samples[index] = {
            ...samples[index],
            name: name,
            selection: selection
        };
        this.props.actions.changeSamples(samples);
    }

    storeSamples() {
        return this.props.store.samples
    }

    samples() {
        return this.storeSamples().map((sample, index)=> {
            return (
                <SampleInput
                    key={index}
                    index={index}
                    store={this.props.store}
                    actions={this.props.actions}
                    removeSample={this.removeSample}
                    chooseSample={this.chooseSample}
                    options={this.state.options}
                    missing_message={'No beers for this brewery'}
                    input_name={'beer_selection'}
                />
            );
        })
    }

    render() {
        return (
            <div className="add-sample-div">
                <div className="text-left margin_top_sm">
                    <div className='samples-list new-order-padded'>
                        {this.samples()}
                    </div>
                </div>
                <a id="add_sample" className="add-beer" onClick={this.clickOnAddSample}>+</a>
                <div className="click-the">← Click here to add another product</div>

            </div>
        );
    }
}

export default AddSample